import { render } from "./HeatmapPrefecture.vue?vue&type=template&id=39e5343a"
import script from "./HeatmapPrefecture.vue?vue&type=script&lang=js"
export * from "./HeatmapPrefecture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__